import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "15",
    height: "16",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const EarnSkills = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M2.36718 16V12.56C1.61757 11.864 1.03367 11.056 0.623356 10.128C0.213046 9.2 0 8.224 0 7.2C0 5.2 0.694371 3.496 2.07522 2.096C3.45608 0.696 5.12888 0 7.10153 0C8.74277 0 10.2025 0.488 11.4729 1.472C12.7433 2.456 13.5639 3.728 13.9506 5.304L14.9763 9.408C15.0395 9.664 15 9.888 14.8343 10.096C14.6686 10.304 14.4634 10.408 14.2031 10.408H12.6249V12.808C12.6249 13.248 12.4671 13.624 12.1594 13.936C11.8517 14.248 11.4808 14.408 11.0468 14.408H9.4687V16.008H7.89058V12.808H11.0468V8.808H13.1773L12.4277 5.704C12.1278 4.488 11.4808 3.504 10.4945 2.744C9.50815 1.984 8.3798 1.6 7.10153 1.6C5.57864 1.6 4.2767 2.144 3.19569 3.224C2.11468 4.304 1.57812 5.616 1.57812 7.168C1.57812 7.968 1.73593 8.728 2.05944 9.448C2.38296 10.168 2.84061 10.808 3.4324 11.368L3.94529 11.848V16.008H2.36718V16ZM6.31247 10.4H7.89058L8.00894 9.4C8.11152 9.36 8.20621 9.312 8.293 9.256C8.3798 9.2 8.45082 9.144 8.52183 9.072L9.42925 9.472L10.2183 8.112L9.42925 7.512C9.45292 7.408 9.4687 7.296 9.4687 7.192C9.4687 7.088 9.45292 6.976 9.42925 6.872L10.2183 6.272L9.42925 4.912L8.52183 5.312C8.45871 5.248 8.3798 5.184 8.293 5.128C8.20621 5.072 8.11152 5.024 8.00894 4.984L7.89058 3.984H6.31247L6.19411 4.984C6.09153 5.024 5.99684 5.072 5.91005 5.128C5.82325 5.184 5.75224 5.24 5.68122 5.312L4.7738 4.912L3.98475 6.272L4.7738 6.872C4.75013 6.976 4.73435 7.088 4.73435 7.192C4.73435 7.296 4.75013 7.408 4.7738 7.512L3.98475 8.112L4.7738 9.472L5.68122 9.072C5.74434 9.136 5.82325 9.2 5.91005 9.256C5.99684 9.312 6.09153 9.36 6.19411 9.4L6.31247 10.4ZM7.10153 8.4C6.77012 8.4 6.49395 8.28 6.26512 8.048C6.0363 7.816 5.91794 7.528 5.91794 7.2C5.91794 6.872 6.0363 6.584 6.26512 6.352C6.49395 6.12 6.77801 6 7.10153 6C7.42504 6 7.7091 6.12 7.93793 6.352C8.16675 6.584 8.28511 6.872 8.28511 7.2C8.28511 7.528 8.16675 7.816 7.93793 8.048C7.7091 8.28 7.42504 8.4 7.10153 8.4Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default EarnSkills;
